import { Button } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const CopyTenantsToBreezeMSSPButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: colors.feasibility_high_bg,
        "&:hover": {
          backgroundColor: colors.feasibility_high_bg_hover,
        },
      }}
      onClick={handleOnClick}
    >
      Copy Tenants to Breeze MSSP
    </Button>
  );
};

export default CopyTenantsToBreezeMSSPButton;

